const colorMapping = {
    'Beige': '#CEA482',
    'Blauw': '#027BFF',
    'Oranje': '#FD7E14',
    'Paars': '#6F42C1',
    'Bruin': '#8C6B57',
    'Rood': '#DC3545',
    'Geel': '#FFC008',
    'Wit': '#FCFCFC',
    'Grijs': '#666666',
    'Zilver': '#666666',
    'Groen': '#00B67A',
    'Zwart': '#000000'
}

export default colorMapping
